import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { ILoginViewModel } from 'app/models/ILoginViewModel';
import { IUser } from '../models/IUser';
import { IResetPassword } from 'app/models/IResetPassword';
import { AlertService } from 'app/services/alert.service';
import { BaseService } from '../services/base.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import * as JwtDecode from 'jwt-decode';
import { IOrg } from '../models/IOrg';



//let config = require('../../config').appConfig;

@Injectable()
export class AuthService {

    public user: IUser;
    public orgs: IOrg[];
    public routeVisible: boolean;


    constructor(private router: Router,
        private alertService: AlertService,
        private baseService: BaseService
        ) {
        //super();
        if (localStorage.getItem('currentUser')) {
            this.user = JSON.parse(localStorage.getItem('currentUser'));
            this.orgs = JSON.parse(this.user.orgs);
        }

    }

    login(model: ILoginViewModel, returnUrl: string) {
        return this.baseService.sendHttpPost('/auth/login', model).subscribe(
            response => {

                this.user = JwtDecode(response.value.token) as IUser;
                this.orgs = JSON.parse(this.user.orgs);
                //this.user.roles = '"roles":["Administrators","Football Playoff User","Nascar User"]'
                localStorage.setItem('token', response.value.token);
                localStorage.setItem('currentUser', JSON.stringify(this.user));
                this.router.navigate([returnUrl]);
            },
            error => { this.alertService.error(error) }
        );
    }

    logout() {
        // return this.baseService.sendHttpPost('/auth/logout', null).subscribe(
        //     response => {
        //         this.user = null;
        //         localStorage.removeItem('currentUser');
        //         localStorage.removeItem('token');
        //         this.router.navigate(['/dashboard']);
        //     },
        //     error => { this.alertService.error(error) }
        // );

                this.user = null;
                localStorage.removeItem('currentUser');
                localStorage.removeItem('token');
                this.router.navigate(['/dashboard']);


    }


    register(model: IUser, route: string) {
        return this.baseService.sendHttpPost('/auth/register', model).subscribe(
            response => {
                //let user = response.json()
                if (response.value)
                    this.user = JwtDecode(response.value.token) as IUser;
                localStorage.setItem('token', response.value.token);
                localStorage.setItem('currentUser', JSON.stringify(this.user));
                this.orgs = JSON.parse(this.user.orgs);
                this.router.navigate([route]);
            }
        )
    }

    isLoggedIn() {
        if (localStorage.getItem('currentUser')) {
            return true;
        }
        else
            return false;

    }

    changePassword(value) {
        value.id = this.user.id;
        return this.baseService.sendHttpPost('/auth/changePassword', value);
    }

    resetPassword(value: IResetPassword) {
        return this.baseService.sendHttpPost('/auth/resetPassword', value);
    }

    isInRole(role: string) {
        var inRole: boolean = false;
        if (this.isLoggedIn()) {
            if (this.user.roles) {
                this.user.roles.forEach(userRole => {
                    if (userRole == role) {
                        //this.router.navigate(route.url);
                        inRole = true;
                    }
                });
            }
        }
        return inRole;
    }


}


// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/account/auth.service.ts